export const durationMap = {
  '1': 'День',
  '2': 'Неделя',
  '3': 'Месяц'
};
